import { css } from "styled-components";
import { color } from "./color";
export const focusRing = (props = { type: "default" }) => {
    switch (props.type) {
        case "inner":
            return css `
        box-shadow: 0px 0px 0px 2px ${color("base", { palette: "interactiveConstructive" })} inset;
        outline: 2px solid transparent; // high contrast mode compatibility
        outline-offset: -2px;
      `;
        // Taken from https://remysharp.com/til/css/focus-ring-default-styles
        case "native":
            return css `
        outline: 5px auto Highlight;
        outline: 5px auto -webkit-focus-ring-color;
      `;
        default:
            return css `
        box-shadow: 0px 0px 0px 2px ${color("base", { palette: "interactiveConstructive" })};
        outline: 2px solid transparent; // high contrast mode compatibility
      `;
    }
};
